import {Exist} from "components/Exist";
import {HOCModal} from "components/HOCModal";
import {HOCModalCenterDesktopPosition} from "components/HOCModalCenterDesktopPosition";
import {getUserStore} from "modules/selectors";
import {useIsMobile} from "modules/utils/hooks";
import React, {Fragment, useState, useEffect} from "react";
import {Trans, useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import styled from "@emotion/styled";
import {getLogoAccordingState} from "modules/utils/dom_helpers";

const Wrapper = styled.div`
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
`;

const Logo = styled.div`
	margin: 0 auto;
	display: block;
	max-width: 125px;
	min-height: 120px;
	padding-bottom: 30px;
	background: transparent;
	border: none;
	box-shadow: none;
	cursor: auto;
	img {
		width: 100%;
		height: 100%;
	}
`;

const Controls = styled.div``;

const Title = styled.p`
	font-weight: 800;
	font-size: 30px;
	line-height: 28px;
	text-align: center;
`;

const Description = styled.div`
	text-align: left;
	color: #ffff;
	font-size: 14px;
	max-width: 90%;
	width: 100%;
	padding: 20px;
	margin: 0 auto;
	ul {
		padding: 0 20px;
		li {
			list-style: disc;
			line-height: 1.8;
		}
	}
`;

interface IProps {
	onPass: () => void;
}

export const SecretModal: React.FC<IProps> = ({onPass}) => {
	const i18n = useTranslation();
	const isMobile = useIsMobile();
	const {countryCode, stateCode} = useSelector(getUserStore);
	const [clicksCount, setClickCount] = useState(0);

	useEffect(() => {
		const SECRET_KEY = 20;
		if (clicksCount >= SECRET_KEY) {
			onPass();
		}
	}, [clicksCount, onPass]);

	const onClick = () => setClickCount(clicksCount + 1);

	const Content = () => (
		<Wrapper>
			<Controls>
				<Logo onClick={onClick}>
					<img
						src={getLogoAccordingState(countryCode, stateCode)}
						alt="The main logo of MLB"
					/>
				</Logo>

				<Title>{i18n.t("coming_soon.content.title", "Title")}</Title>

				<Description>
					<ul>
						<Trans i18nKey={"coming_soon.content.body"}>
							<li>content</li>
						</Trans>
					</ul>
				</Description>
			</Controls>
		</Wrapper>
	);

	const props = {
		isOpen: true,
		name: "secret-modal",
		headerText: <Fragment>{i18n.t("coming_soon.header.title", "Coming soon..")}</Fragment>,
	};

	return (
		<Fragment>
			<Exist when={isMobile}>
				<HOCModal {...props} hideCrossButton={true}>
					<Content />
				</HOCModal>
			</Exist>
			<Exist when={!isMobile}>
				<HOCModalCenterDesktopPosition {...props}>
					<Content />
				</HOCModalCenterDesktopPosition>
			</Exist>
		</Fragment>
	);
};
